import React, { useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet';
import './PolymatchDetail.css';
import StudentNav from '../Navbars/StudentNav';
import AdminNav from '../Navbars/AdminNav';
import TeacherNav from '../Navbars/TeacherNav';
import { Link } from "react-router-dom";
import { UserContext } from '../UserContext';
import Footer from "../Footer";
import { useNavigate } from 'react-router-dom';
import polymatchImage from '../../assets/Polymatch.png';
import pmdImage from '../../assets/pmd.png';
import pmd1Image from '../../assets/pmd1.png';
import aboutIconImage from '../../assets/abouticon.png';
import WebFont from 'webfontloader';

const PolymatchDetail = () => {
    const { isAdmin, isTeacher, isStudent, userInfo, setUserRole, setUserInfo } = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        WebFont.load({
            google: {
                families: ['Baumans']
            }
        });
        const fetchData = async () => {
            await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
                credentials: 'include',
            }).then(response => {
                response.json().then(userInfo => {
                    setUserInfo(userInfo);
                    if (userInfo?.usertype) {
                        setUserRole(userInfo.usertype);
                    }
                });
            }).catch(err => console.log("Error in useEffect:", err));
        };
        fetchData();
    }, [setUserInfo, setUserRole]);

    const onLogout = () => {
        fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
            credentials: 'include',
            method: 'POST',
        });
        setUserInfo(null);
        setUserRole('guest');
        navigate('/');
    };

    const username = userInfo?.username;
    const _avatar_ = userInfo?.avatar;

    return (
        <>
            <Helmet>
                <title>PolyMatch 2026 Global Islamic Knowledge Competition - Polymath-Kids</title>
                <meta
                    name="description"
                    content="Learn about the PolyMatch 2026 Global Islamic Knowledge Competition, including registration guidelines, disclaimers, and policies. Join the global stage to showcase your skills!"
                />
                <meta name="keywords" content="PolyMatch, islamic knowledge, competition, Polymath-Kids, registration, disclaimers" />
                <meta name="robots" content="index, follow" />
            </Helmet>

            {username && (
                <>
                    {isAdmin && <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />}
                    {isTeacher && <TeacherNav username={username} avatar={_avatar_} onLogout={onLogout} />}
                    {isStudent && <StudentNav username={username} avatar={_avatar_} onLogout={onLogout} />}
                </>
            )}

            <div className="PolymatchBgg">
                {/* Section 1: Registration Guidelines & Important Disclaimers */}
                <section className="polymatch-section-1">
                    <h1 className="polymatch-heading">
                        <span className="highlight-purple">Registration Guidelines &</span>{' '}
                        <span className="highlight-pink">Important Disclaimers</span>
                    </h1>
                    <p className="polymatch-description">
                        Please read the information below carefully before proceeding. This includes essential registration rules, competition policies, authentication steps, tie-breaker procedures, and our no-refund and modification policies. By registering, you agree to comply with these terms.
                    </p>
                    <div className="polymatch-detail-buttons">
                        <Link to="/PolymatchReg" className="registerBtn">Register</Link>
                    </div>
                    <img src={pmdImage} alt="PMD Icon Left" className="pmd-icon-left" />
                    <img src={pmd1Image} alt="PMD Icon Right" className="pmd-icon-right" />
                </section>

                {/* Section 2: General Disclaimers */}
                <section className="polymatch-section-2">
                    <img src={polymatchImage} alt="Polymatch Logo" className="polymatch-logo" />
                    <h2 className="disclaimer-heading">General Disclaimers</h2>
                    <p> Please read the information below carefully before proceeding. This includes essential registration rules, competition policies, authentication steps, and our no-refund and modification policies. By registering, you agree to comply with these terms.</p>
                    <div className="disclaimer-content">
                        <p><strong>Network Issues:</strong> PolyMatch by Polymath-Kids is not responsible for any interruptions, delays, or disconnections caused by internet or network problems during the competition. Participants are strongly advised to ensure a stable and reliable internet connection before joining the event.</p>
                        <p><strong>Contestant Authentication:</strong> All participants must attempt the competition using the registered email ID and phone number on the PolyMatch app. </p>
                        <p><strong>WhatsApp Group Responsibility:</strong> After registration, parents are required to join the official WhatsApp group links shared with them. All important updates, announcements, and instructions are communicated exclusively through these groups. Failure to join these groups may result in missing critical information, and no refunds or adjustments will be made in such cases.</p>
                        <p><strong>No Refund & No Transfer Policy:</strong> All registrations are non-refundable and non-transferable. Once registration and payment are confirmed, no refunds, transfers, or modifications will be permitted under any circumstances. Participants are advised to review all details carefully before submitting their registration.
                        </p>
                        <p><strong>Dispute Resolution:</strong> In case of any disputes, complaints, or concerns related to the competition, the decision of the PolyMatch by Polymath-Kids Organizing Committee shall be final and binding.</p>
                        <p><strong>Terms and Conditions:</strong> The organizers reserve the right to modify, update, or amend the terms and conditions of the competition at any time without prior notice.</p>
                        <p><strong>No Refund Policy:</strong> We regret to inform you that our events operate under a strict no-refund policy. Once registration is confirmed, no refunds will be provided for any reason.</p>
                        {/* <p><strong>Cancellation and Modification:</strong> Participants are reminded that registrations, once confirmed, cannot be cancelled or modified. We appreciate your understanding in adhering to this policy.</p> */}
                        <p><strong>Event Changes:</strong> PolyMatch by Polymath-Kids reserves the right to modify event dates, formats, or schedules when necessary. Participants will be informed of any such changes through official communication channels.</p>
                        <p><strong>Force Majeure:</strong> outages, or other force majeure situations—the organizers may postpone, adjust, or cancel the event as deemed necessary to ensure fairness and safety.</p>
                        <p><strong>Acknowledgment:</strong> By registering for PolyMatch by Polymath-Kids, participants acknowledge and agree to abide by all terms, conditions, and policies stated above. For any questions or clarifications, please contact our support team.</p>
                        <p><strong>Information Sources:</strong> Parents, schools, and participants are encouraged to stay updated by following our official Facebook page: “PolyMatch by Polymath-Kids”.</p>
                        <p><strong>Official Website:</strong> For complete details, schedules, and updates, please visit: www.polymath-kids.com</p>
                        {/* <p>These disclaimers are designed to ensure a fair and smooth experience for all participants. Please review them carefully before participating in the PolyMatch Mental Math Competition 2024.</p> */}
                    </div>
                </section>

                {/* Stay Tuned Section */}
                <section className="stay-tuned-section">
                    <div className="stay-tuned-content">
                        <img src={aboutIconImage} alt="About Icon" className="stay-tuned-icon" />
                        <h3 className="stay-tuned-heading">STAY TUNED FOR MORE COMPETITIONS</h3>
                    </div>
                </section>
            </div>

            <Footer />
        </>
    );
};

export default PolymatchDetail;